/**
 * 記事の添付ファイルのURLを生成するフィルタ。
 */
import _ from 'lodash'

/**
 * 記事の添付ファイルのURLを生成する。使い方は以下の通り
 * {{ fileName.png | attachmentUrl(siteId, contentId) }}
 *
 * @param {string} fileName - ファイル名
 * @param {number} siteId - サイトID
 * @param {number} contentId - コンテンツID
 */
export default function attachmentUrl(fileName: string, siteId: number, contentId: number) {
  // contentID は 12桁に0パディングしたあと、3桁単位で/区切りを行う
  const paddedContentId = _.padStart(contentId.toString(), 12, '0')
  const urlContentId = _.chunk(paddedContentId.split(''), 3)
    .map(part => part.join(''))
    .join('/')
  const baseUrl = process.env.GERBERA_BASE_URL
  return `${baseUrl}/cpool/${siteId}/${urlContentId}/${fileName}`
}
